import axios from "axios";
import HostService from "./host.service";
import AuthService from "./auth.service";
import Contenedor from "../models/Contenedor";


class ContenedoresService {

    /**
     * Obtener contenedores
     * @param id_incidencia
     * @returns {Promise<AxiosResponse<any>>}
     */
    static obtenerContenedores(ejercicio) {
        return axios.get(HostService.getHost() + 'contenedores?ejercicio='+ejercicio, AuthService.setToken())
            .then((response) => {
                return response.data.map(Contenedor.from);
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }

    /**
     * Registrar un contenedor
     * @param contenedor
     * @returns {Promise<AxiosResponse<any>>}
     */
    static registrarContenedor(contenedor) {

        const formData = new FormData();

        // Campos planos
        formData.append('contenedor', contenedor.contenedor);
        formData.append('concepto', contenedor.concepto);
        formData.append('naviera', contenedor.naviera);
        formData.append('preparador', contenedor.preparador);
        formData.append('comentarios', contenedor.comentarios);

        if (contenedor.fecha_llegada_muelle) {
            formData.append('fecha_llegada_muelle', contenedor.fecha_llegada_muelle);
        }
        if (contenedor.fecha_llegada) {
            formData.append('fecha_llegada', contenedor.fecha_llegada);
        }
        if (contenedor.fecha_salida) {
            formData.append('fecha_salida', contenedor.fecha_salida);
        }
        if (contenedor.fecha_aviso) {
            formData.append('fecha_aviso', contenedor.fecha_aviso);
        }

        formData.append('almacen', contenedor.almacen);
        formData.append('ejercicio', contenedor.ejercicio);
        formData.append('es_exportacion', contenedor.es_exportacion);

        if (Array.isArray(contenedor.documentos)) {
            contenedor.documentos.forEach((doc) => {
                formData.append('imagenes[]', doc);
            });
        }

        return axios.post(
            HostService.getHost() + 'contenedores',
            formData,
            {
                headers: {
                    ...AuthService.setToken().headers,
                }
            }
        ).then((response) => {
            return Contenedor.from(response.data);
        })
        .catch((error) => {
            console.log(error.message);
            throw error;
        });
    }

    /**
     * Registrar un contenedor
     * @param contenedor
     * @returns {Promise<AxiosResponse<any>>}
     */
    static actualizarContenedor(contenedor) {

        const formData = new FormData();

        // Campos planos
        formData.append('contenedor', contenedor.contenedor);
        formData.append('concepto', contenedor.concepto);
        formData.append('naviera', contenedor.naviera);
        formData.append('preparador', contenedor.preparador);
        formData.append('comentarios', contenedor.comentarios);

        if (contenedor.fecha_llegada_muelle) {
            formData.append('fecha_llegada_muelle', contenedor.fecha_llegada_muelle);
        }
        if (contenedor.fecha_llegada) {
            formData.append('fecha_llegada', contenedor.fecha_llegada);
        }
        if (contenedor.fecha_salida) {
            formData.append('fecha_salida', contenedor.fecha_salida);
        }
        if (contenedor.fecha_aviso) {
            formData.append('fecha_aviso', contenedor.fecha_aviso);
        }

        formData.append('almacen', contenedor.almacen);
        formData.append('ejercicio', contenedor.ejercicio);
        formData.append('es_exportacion', contenedor.es_exportacion);

        if (Array.isArray(contenedor.documentos)) {
            contenedor.documentos.forEach((doc) => {
                formData.append('imagenes[]', doc);
            });
        }

        return axios.put(
            HostService.getHost() + 'contenedores/'+contenedor.id,
            formData,
            {
                headers: {
                    ...AuthService.setToken().headers,
                }
            }
        ).then((response) => {
            return Contenedor.from(response.data);
        }).catch((error) => {
            console.log(error.message);
            throw error;
        });
    }

    /**
     * Eliminar contenedor
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static eliminarContenedor(id) {
        return axios.delete(HostService.getHost() + 'contenedores/'+id, AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }

    /**
     * Eliminar documento contenedor
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static eliminarDocumentoContenedor(idContenedor, idDocumento) {
        return axios.delete(HostService.getHost() + 'contenedores/'+idContenedor+'/documento/'+idDocumento, AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }
}

export default ContenedoresService;